export default "__VITE_ASSET__0G5fmiIy__"